module.exports = __webpack_public_path__ + "static/img/guide01.0ab47f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c22/guide01.png
// module id = 4584
// module chunks = 1